// COA & SDS Modal System
// Extracted from theme.liquid for better performance

var _learnq = window._learnq || [];

// --- 1. DATA PREPARATION ---
const allProductsDataRaw = window.coaProductsData || [];
const allSdsDataRaw = window.coaSdsData || [];

function getSortableValue(sizeString) {
  if (!sizeString) return Infinity;
  const lowerSizeString = sizeString.toLowerCase();
  const match = lowerSizeString.match(/(\d*\.?\d+)/);
  if (!match) return Infinity;
  const number = parseFloat(match[1]);
  let multiplier = 1;
  if (lowerSizeString.includes('gallon') || lowerSizeString.includes('gal')) multiplier = 128;
  else if (lowerSizeString.includes('quart') || lowerSizeString.includes('qt')) multiplier = 32;
  else if (lowerSizeString.includes('pint') || lowerSizeString.includes('pt')) multiplier = 16;
  else if (lowerSizeString.includes('oz')) multiplier = 1;
  else if (lowerSizeString.includes('lbs') || lowerSizeString.includes('lb')) multiplier = 16;
  else if (lowerSizeString.includes('drum')) multiplier = 128 * 55;
  return number * multiplier;
}

const allProductsData = allProductsDataRaw.map(p => {
  const displayOption = p.options[1] || '';
  const displayName = `${p.productTitle} - ${displayOption}`.trim();
  const fullSearchableString = `${p.productTitle} ${p.options.join(' ')} ${p.sku || ''}`.toLowerCase();
  const sortValue = getSortableValue(p.options[1]);
  return { ...p, displayOption, displayName, fullSearchableString, sortValue };
});

allProductsData.sort((a, b) => {
  if (a.productTitle < b.productTitle) return -1;
  if (a.productTitle > b.productTitle) return 1;
  return a.sortValue - b.sortValue;
});

const allSdsData = allSdsDataRaw.sort((a, b) => a.productTitle.localeCompare(b.productTitle));

let selectedProducts = [];

function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => { clearTimeout(timeout); func(...args); };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// --- 2. COA MODAL FUNCTIONS ---
function openCOAForm() {
  document.getElementById('coa-modal').style.display = 'block';
  document.body.style.overflow = 'hidden';
  selectedProducts = [];
  document.getElementById('selected-products').innerHTML = '';
  document.getElementById('coa-request-form').reset();
  document.getElementById('coa-product-selector-wrapper').style.display = 'block';
  document.getElementById('coa-request-form').style.display = 'block';
  document.getElementById('coa-success-message').style.display = 'none';
  updateProgress(1);
}

function closeCOAForm() {
  document.getElementById('coa-modal').style.display = 'none';
  document.body.style.overflow = 'auto';
}

function setupProductSelector() {
  const searchInput = document.getElementById('product-search-input');
  const wrapper = document.getElementById('coa-product-selector-wrapper');
  const resultsContainer = document.createElement('div');
  resultsContainer.className = 'coa-product-selector-results';
  wrapper.appendChild(resultsContainer);

  const renderResults = (products) => {
    resultsContainer.innerHTML = products.length === 0
      ? '<div class="coa-product-result" style="cursor:default;">No products found.</div>'
      : products.map(p => {
          const safeDisplayName = p.displayName.replace(/'/g, "\\'").replace(/"/g, "&quot;");
          const safeSku = p.sku ? p.sku.replace(/'/g, "\\'").replace(/"/g, "&quot;") : '';
          const skuDisplay = p.sku ? `<span class="result-variant-sku">SKU: ${p.sku}</span>` : '';
          return `
            <div class="coa-product-result" onclick="selectProduct('${safeDisplayName}', '${safeSku}')" title="${p.displayName}">
              <strong class="result-product-title">${p.productTitle}</strong>
              <div class="result-variant-details">
                <span class="result-variant-options">${p.displayOption}</span>
                ${skuDisplay}
              </div>
            </div>`;
        }).join('');
  };

  const debouncedSearchHandler = debounce(() => {
    const query = searchInput.value.toLowerCase();
    const filtered = query === '' ? allProductsData : allProductsData.filter(p => p.fullSearchableString.includes(query));
    renderResults(filtered);
  }, 250);
  
  searchInput.addEventListener('input', debouncedSearchHandler);
  searchInput.addEventListener('focus', () => {
    renderResults(allProductsData);
    resultsContainer.classList.add('visible');
  });
  document.addEventListener('click', (e) => {
    if (!wrapper.contains(e.target)) {
      resultsContainer.classList.remove('visible');
    }
  });
}

function selectProduct(displayName, sku) {
  if (selectedProducts.length >= 9) {
    document.getElementById('coa-product-selector-wrapper').style.display = 'none';
  }
  if (selectedProducts.length >= 10) {
    alert('Maximum of 10 products allowed per request.');
    return;
  }

  selectedProducts.push({ name: displayName, sku: sku });
  const skuHtml = sku ? `<div class="coa-product-sku">SKU: ${sku}</div>` : '';
  const productCard = `
    <div class="coa-product-card" data-name="${displayName}" data-sku="${sku || ''}">
      <div class="coa-product-card-header">
        <span class="coa-product-badge">Product #${selectedProducts.length}</span>
        <button type="button" class="coa-remove-btn" onclick="removeProduct(this)">&times;</button>
      </div>
      <div class="coa-product-name">${displayName}</div>
      ${skuHtml}
      <input type="text" class="coa-lot-input" placeholder="Enter lot number from product label" required>
    </div>`;
  document.getElementById('selected-products').insertAdjacentHTML('beforeend', productCard);
  const searchInput = document.getElementById('product-search-input');
  searchInput.value = '';
  searchInput.placeholder = 'Add another product...';
  document.querySelector('.coa-product-selector-results').classList.remove('visible');
}

function removeProduct(button) {
  const card = button.closest('.coa-product-card');
  selectedProducts = selectedProducts.filter(p => p.name !== card.dataset.name);
  card.remove();
  document.querySelectorAll('.coa-product-badge').forEach((badge, index) => {
    badge.textContent = `Product #${index + 1}`;
  });
  if (selectedProducts.length < 10) {
    document.getElementById('coa-product-selector-wrapper').style.display = 'block';
  }
}

function updateProgress(currentStep) {
  document.querySelectorAll('.coa-progress-step').forEach(step => {
    const stepNumber = parseInt(step.dataset.step, 10);
    step.classList.remove('active', 'completed');
    if (stepNumber < currentStep) {
      step.classList.add('completed');
    } else if (stepNumber === currentStep) {
      step.classList.add('active');
    }
  });
}

function setupProgressHandlers() {
  document.querySelectorAll('.coa-section[data-section]').forEach(section => {
    section.addEventListener('focusin', () => {
      updateProgress(parseInt(section.dataset.section, 10));
    });
  });
}

function sendCOAEventToKlaviyo(customerData) {
  if (typeof _learnq !== 'undefined') {
    _learnq.push(['identify', {
        '$email': customerData.email,
        '$first_name': customerData.name,
        'Company': customerData.company || '',
        'Phone': customerData.phone || ''
    }]);
    
    _learnq.push(['track', 'Requested COA', {
        'Order Number': customerData.orderNumber,
        'Products': customerData.products,
        'Lot Numbers': customerData.lotNumbers,
        'Timestamp': new Date().toISOString()
    }]);
  }
}

function setupFormHandling() {
    const form = document.getElementById('coa-request-form');
    const submitButton = form.querySelector('.coa-submit-btn');
    
    form.addEventListener('submit', function(e) {
      // --- 1. VALIDATION ---
      if (selectedProducts.length === 0) {
        e.preventDefault(); // Stop the submission
        alert('Please add at least one product to your COA request.');
        return;
      }

      let allLotNumbersFilled = true;
      document.querySelectorAll('.coa-product-card .coa-lot-input').forEach(lotInput => {
        if (!lotInput.value) {
          allLotNumbersFilled = false;
          lotInput.style.borderColor = '#ff4444';
        } else {
          lotInput.style.borderColor = '#e0e0e0';
        }
      });

      if (!allLotNumbersFilled) {
        e.preventDefault(); // Stop the submission
        alert('Please enter a lot number for all selected products.');
        return;
      }

      // --- 2. DATA PREPARATION ---
      let productsForKlaviyo = [];
      let lotNumbersForKlaviyo = [];
      let productsForSummary = [];

      document.querySelectorAll('.coa-product-card').forEach((card, index) => {
        const productName = card.dataset.name;
        const productSku = card.dataset.sku || 'N/A';
        const lotInput = card.querySelector('.coa-lot-input');
        
        productsForKlaviyo.push(productName);
        lotNumbersForKlaviyo.push(lotInput.value || '');
        productsForSummary.push(`Product ${index + 1}: ${productName} (SKU: ${productSku}) | Lot#: ${lotInput.value || 'NOT PROVIDED'}`);
      });

      // --- 3. THIRD-PARTY INTEGRATION (KLAVIYO) ---
      const customerData = {
        email: document.getElementById('coa-email').value,
        name: document.getElementById('coa-name').value,
        company: document.getElementById('coa-company').value || '',
        phone: document.getElementById('coa-phone').value || '',
        orderNumber: document.getElementById('coa-order-number').value,
        products: productsForKlaviyo,
        lotNumbers: lotNumbersForKlaviyo
      };
      sendCOAEventToKlaviyo(customerData);

      // --- 4. PREPARE FORM FOR SUBMISSION ---
      const notes = document.getElementById('coa-message-notes').value;
      let fullMessageBody = 'PRODUCTS REQUESTED:\n' + productsForSummary.join('\n');
      if (notes) {
        fullMessageBody += '\n\nADDITIONAL INFO:\n' + notes;
      }
      document.getElementById('coa-body-summary').value = fullMessageBody;

      submitButton.disabled = true;
      submitButton.textContent = 'Submitting...';

      sessionStorage.setItem('coaFormSubmitted', 'true');

      // --- 5. ALLOW BROWSER TO SUBMIT ---
      // We DO NOT call e.preventDefault() here, so the form submits normally.
    });
  }

// --- 3. SDS MODAL FUNCTIONS ---
function openSdsModal() {
  document.getElementById('sds-modal').style.display = 'block';
  document.body.style.overflow = 'hidden';
}

function closeSdsModal() {
  document.getElementById('sds-modal').style.display = 'none';
  document.body.style.overflow = 'auto';
}

function setupSdsModal() {
  const searchInput = document.getElementById('sds-search-input');
  const listContainer = document.getElementById('sds-list-container');

  const renderSdsList = (sdsItems) => {
    listContainer.innerHTML = sdsItems.length === 0
      ? '<p>No matching SDS found.</p>'
      : sdsItems.map(sds => `
          <div class="sds-list-item">
            <span class="sds-product-title">${sds.productTitle}</span>
            <a href="${sds.sdsUrl}" class="sds-download-link" target="_blank">View SDS</a>
          </div>`).join('');
  };

  renderSdsList(allSdsData);

  searchInput.addEventListener('input', debounce(() => {
    const query = searchInput.value.toLowerCase();
    const filtered = allSdsData.filter(sds => sds.productTitle.toLowerCase().includes(query));
    renderSdsList(filtered);
  }, 250));
}

// --- 4. INITIALIZATION ---

window.onclick = function(event) {
  if (event.target.id === 'coa-modal') closeCOAForm();
  if (event.target.id === 'sds-modal') closeSdsModal();
};

// Make functions globally accessible
window.openCOAForm = openCOAForm;
window.closeCOAForm = closeCOAForm;
window.openSdsModal = openSdsModal;
window.closeSdsModal = closeSdsModal;
window.selectProduct = selectProduct;
window.removeProduct = removeProduct;

document.addEventListener('DOMContentLoaded', function () {
  // --- Show success message after page reload ---
  if (sessionStorage.getItem('coaFormSubmitted') === 'true') {
    sessionStorage.removeItem('coaFormSubmitted');
    const successDiv = document.createElement('div');
    successDiv.style.cssText = 'position:fixed;top:20px;right:20px;background:#28a745;color:white;padding:15px 25px;border-radius:8px;z-index:10000;font-size:16px;box-shadow:0 4px 15px rgba(0,0,0,0.2);';
    successDiv.textContent = 'COA Request submitted! We\'ll email your certificates within 1-2 business days.';
    document.body.appendChild(successDiv);
    setTimeout(() => {
      successDiv.style.transition = 'opacity 0.5s';
      successDiv.style.opacity = '0';
      setTimeout(() => successDiv.remove(), 500);
    }, 5000);
  }

  // --- Initialize other features ---
  if (typeof AOS !== 'undefined') { AOS.init({ easing: 'ease', once: true, duration: 1000, offset: 60, disableMutationObserver: true }); }
  if (typeof universalParallax !== 'undefined') { new universalParallax().init({ speed: 10 }); }

  setupProductSelector();
  setupFormHandling();
  setupProgressHandlers();
  setupSdsModal();
});